import React, { Component } from "react";
//import { CareesJobApplication_SideBar } from "../layouts/about/carees/CareesJobApplication_SideBar";
import CareesJobApplication_BannerTitle from "../layouts/about/carees/CareesJobApplication_BannerTitle";
import CareesJobApplication_SiteContent from "../layouts/about/carees/CareesJobApplication_SiteContent";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
class AboutCareesJobApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "../assets/img/logo-small.png",
          names: "About Us",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/about-us",
          titlelink: "About Us",
          border: "|",
          name: "Careers",
          heading: "Careers",
        },
      ],
    };
  }
  render() {
    return (
      <div className="header-fixed page sidebar-right header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <CareesJobApplication_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <CareesJobApplication_SiteContent />
              </div>
            </div>
          </div>
          <Footer />
          {this.state.headers.map((data, idx) => (
            <BottomBar data={data} key={idx} />
          ))}
        </div>
      </div>
    );
  }
}

export default AboutCareesJobApplication;
